import React, { JSX } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { SnackbarNotificationType, snackbarSlice } from 'Douleutaras/redux/data/ui/snackbarSlice';

import './SnackbarItem.scss';

interface SnackbarItemProps {
  type: SnackbarNotificationType;
  text: string | JSX.Element;
  dismissible?: boolean;
  id?: string;
}

export const SnackbarItem: React.FC<SnackbarItemProps> = ({ type, text, id, dismissible = false }) => {
  const dispatch = useDispatch();

  return (
    <div key={`key_${id}`} styleName={classNames({
      snackbar__item: true,
      'snackbar__item--warning': type === SnackbarNotificationType.WARNING,
      'snackbar__item--error': type === SnackbarNotificationType.ERROR,
      'snackbar__item--success': type === SnackbarNotificationType.SUCCESS,
      'snackbar__item--info': type === SnackbarNotificationType.INFO
    })}>
      <div styleName="snackbar__text">
        { type === SnackbarNotificationType.SUCCESS &&
          <span className="dashicon dashicon-checkmark-circle" styleName="snackbar__text-icon" />
        }
        { type === SnackbarNotificationType.ERROR &&
          <span className="dashicon dashicon-warning-circle" styleName="snackbar__text-icon" />
        }
        { type === SnackbarNotificationType.INFO &&
          <span className="dashicon dashicon-info-circle" styleName="snackbar__text-icon" />
        }
        { text }
      </div>
      { dismissible &&
        <button styleName="snackbar__close"
                type="button"
                aria-label="Close snackbar" // translations?
                onClick={() => dispatch(snackbarSlice.actions.dismissSnackbarNotification({ id }))}>
          <span className="dashicon dashicon-close" styleName="snackbar__close-icon" />
        </button>
      }
    </div>
  );
};
